import { z } from 'zod';

const mergeTargetSchema = z.object({
  id: z.number(),
  title: z.string(),
  slug: z.string(),
  clipCount: z.number(),
});

export const previewTitleChangeResponseSchema = z.object({
  success: z.literal(true),
  data: z.object({
    action: z.enum(['rename', 'merge', 'no-change']),
    slug: z.string(),
    hasPlaceholder: z.boolean(),
    clipCount: z.number(),
    mergeTarget: mergeTargetSchema.optional(),
  }),
});

export type IPreviewTitleChangeResponse = z.infer<typeof previewTitleChangeResponseSchema>;
